export type NativePadding = {
  paddingTop?: number;
  paddingBottom?: number;
  paddingLeft?: number;
  paddingRight?: number;
};

/**
 * Web stub — safe-area and keyboard aren't concepts on web.
 * `react-native-safe-area-context` and `react-native-keyboard-controller`
 * both need native module / provider setup that Next doesn't have.
 *
 * Returns an empty object so spreading the result doesn't clobber a
 * caller's own padding props.
 */
export function useNativePadding(): NativePadding {
  return {};
}